<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "OutputAuthenticityCode" });
import { t } from "svelte-i18n";
export let code;
</script>

{ $t(`resource.auction.properties.authenticity.options.${ code }`) }